import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import commonRu from './locales/ru/common.json';
import layoutRu from './locales/ru/layout.json';
import authRu from './locales/ru/auth.json';
import requestsRu from './locales/ru/requests.json';
import requisitesRu from './locales/ru/requisites.json';
import formsRu from './locales/ru/forms.json';
import balanceRu from './locales/ru/balance.json';
import payoutsRu from './locales/ru/payouts.json';
import penaltiesRu from './locales/ru/penalties.json';
import settingsRu from './locales/ru/settings.json';
import statisticsRu from './locales/ru/statistics.json';
import withdrawalsRu from './locales/ru/withdrawals.json';
import newsRu from './locales/ru/news.json';
import eventsRu from './locales/ru/events.json';
import regulationRu from './locales/ru/regulation.json';

import commonEn from './locales/en/common.json';
import layoutEn from './locales/en/layout.json';
import authEn from './locales/en/auth.json';
import requestsEn from './locales/en/requests.json';
import requisitesEn from './locales/en/requisites.json';
import formsEn from './locales/en/forms.json';
import balanceEn from './locales/en/balance.json';
import payoutsEn from './locales/en/payouts.json';
import penaltiesEn from './locales/en/penalties.json';
import settingsEn from './locales/en/settings.json';
import statisticsEn from './locales/en/statistics.json';
import withdrawalsEn from './locales/en/withdrawals.json';
import newsEn from './locales/en/news.json';
import eventsEn from './locales/en/events.json';
import regulationEn from './locales/en/regulation.json';

import commonUk from './locales/uk/common.json';
import layoutUk from './locales/uk/layout.json';
import authUk from './locales/uk/auth.json';
import requestsUk from './locales/uk/requests.json';
import requisitesUk from './locales/uk/requisites.json';
import formsUk from './locales/uk/forms.json';
import balanceUk from './locales/uk/balance.json';
import payoutsUk from './locales/uk/payouts.json';
import penaltiesUk from './locales/uk/penalties.json';
import settingsUk from './locales/uk/settings.json';
import statisticsUk from './locales/uk/statistics.json';
import withdrawalsUk from './locales/uk/withdrawals.json';
import newsUk from './locales/uk/news.json';
import eventsUk from './locales/uk/events.json';
import regulationUk from './locales/uk/regulation.json';

import commonKz from './locales/kz/common.json';
import layoutKz from './locales/kz/layout.json';
import authKz from './locales/kz/auth.json';
import requestsKz from './locales/kz/requests.json';
import requisitesKz from './locales/kz/requisites.json';
import formsKz from './locales/kz/forms.json';
import balanceKz from './locales/kz/balance.json';
import payoutsKz from './locales/kz/payouts.json';
import penaltiesKz from './locales/kz/penalties.json';
import settingsKz from './locales/kz/settings.json';
import statisticsKz from './locales/kz/statistics.json';
import withdrawalsKz from './locales/kz/withdrawals.json';
import newsKz from './locales/kz/news.json';
import eventsKz from './locales/kz/events.json';
import regulationKz from './locales/kz/regulation.json';

export const LANGUAGES = [
  { code: 'ru', flag: '\u{1F1F7}\u{1F1FA}', label: 'RU' },
  { code: 'en', flag: '\u{1F1EC}\u{1F1E7}', label: 'EN' },
  { code: 'uk', flag: '\u{1F1FA}\u{1F1E6}', label: 'UK' },
  { code: 'kz', flag: '\u{1F1F0}\u{1F1FF}', label: 'KZ' },
];

// Map browser language codes to our supported codes
// e.g. kk (ISO 639-1 for Kazakh) → kz, uk-UA → uk, en-US → en
const SUPPORTED_CODES = ['ru', 'en', 'uk', 'kz'];
const BROWSER_LANG_MAP = { kk: 'kz', 'kk-KZ': 'kz', 'uk-UA': 'uk', 'ru-RU': 'ru', 'en-US': 'en', 'en-GB': 'en' };

const customNavigatorDetector = {
  name: 'customNavigator',
  lookup() {
    const browserLangs = navigator.languages || [navigator.language];
    for (const lang of browserLangs) {
      // Direct match
      if (SUPPORTED_CODES.includes(lang)) return lang;
      // Mapped match (kk → kz, etc.)
      if (BROWSER_LANG_MAP[lang]) return BROWSER_LANG_MAP[lang];
      // Base code match (en-US → en)
      const base = lang.split('-')[0];
      if (SUPPORTED_CODES.includes(base)) return base;
      if (BROWSER_LANG_MAP[base]) return BROWSER_LANG_MAP[base];
    }
    return null;
  },
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector(customNavigatorDetector);

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ru: { common: commonRu, layout: layoutRu, auth: authRu, requests: requestsRu, requisites: requisitesRu, forms: formsRu, balance: balanceRu, payouts: payoutsRu, penalties: penaltiesRu, settings: settingsRu, statistics: statisticsRu, withdrawals: withdrawalsRu, news: newsRu, events: eventsRu, regulation: regulationRu},
      en: { common: commonEn, layout: layoutEn, auth: authEn, requests: requestsEn, requisites: requisitesEn, forms: formsEn, balance: balanceEn, payouts: payoutsEn, penalties: penaltiesEn, settings: settingsEn, statistics: statisticsEn, withdrawals: withdrawalsEn, news: newsEn, events: eventsEn, regulation: regulationEn},
      uk: { common: commonUk, layout: layoutUk, auth: authUk, requests: requestsUk, requisites: requisitesUk, forms: formsUk, balance: balanceUk, payouts: payoutsUk, penalties: penaltiesUk, settings: settingsUk, statistics: statisticsUk, withdrawals: withdrawalsUk, news: newsUk, events: eventsUk, regulation: regulationUk},
      kz: { common: commonKz, layout: layoutKz, auth: authKz, requests: requestsKz, requisites: requisitesKz, forms: formsKz, balance: balanceKz, payouts: payoutsKz, penalties: penaltiesKz, settings: settingsKz, statistics: statisticsKz, withdrawals: withdrawalsKz, news: newsKz, events: eventsKz, regulation: regulationKz},
    },
    supportedLngs: ['ru', 'en', 'uk', 'kz'],
    fallbackLng: 'ru',
    defaultNS: 'common',
    ns: ['common', 'layout', 'auth', 'requests', 'requisites', 'forms', 'balance', 'payouts', 'penalties', 'settings', 'statistics', 'withdrawals', 'news', 'events', 'regulation'],
    detection: {
      order: ['localStorage', 'customNavigator', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
